import React from "react"
import './BlogHero.scss';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Container from "../Container/Container"

const BlogHero = () => {

  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "whatsapp1.PNG" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <Container>
      <div className='showcase'>
      <div className="overlay">
      <div className='content'>
        <h1>Welcome To My Blog</h1>
        <p>Philane Msibi - UI/UX Designer and Software Engineer</p>
      </div>
      </div>
      
      <Img fluid={data.placeholderImage.childImageSharp.fluid} />
  </div>
      </Container>
    </>
  )
}

export default BlogHero
